import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { getGasCriterion } from 'redux/action/criterion';
import AuthRoute from '../session/AuthRoute';
import NotFound from '../error/NotFound';
import GasDetail from './gasDetail/GasDetail';
import GasCriterion from './gasCriterion/GasCriterion';
import GasGraph from './gasGraph/GasGraph';
import GasExcel from './excel/GasExcel';
import './Gas.css';

const Gas = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGasCriterion());
  }, []);

  const [flag, setFlag] = useState(props.flag);
  return (
    <div className="gasContainer">
      <Switch>
        <AuthRoute exact path="/temp" render={(props) => <GasDetail flag={flag} {...props} />} />
        <AuthRoute path="/temp/detail" render={(props) => <GasDetail flag={flag} {...props} />} />
        <AuthRoute path="/temp/criterion" render={(props) => <GasCriterion flag={flag} {...props} />} />
        <AuthRoute path="/temp/graph" render={(props) => <GasGraph flag={flag} {...props} />} />
        <AuthRoute path="/temp/excel" render={(props) => <GasExcel flag={flag} {...props} />} />
        <Route render={NotFound} />
      </Switch>
    </div>
  );
};

export default Gas;
